// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';

import ProAuth from 'utils/ProAuth';

import ActionTypes from 'constants/ActionTypes';
import ApiError from 'PMT/entities/ApiError';

import Restaurant from 'PMT/entities/Restaurant';
import Timelapse from 'PMT/entities/Timelapse';

import { ProAccount } from 'PMT/entities/security';

export default class SessionAction {

  static login(username: string, password: string) {
    ProAuth.login(username, password).then(
      SessionAction.receiveLogin,
      SessionAction.receiveLoginError,
    );
  }

  static receiveLogin() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.LOGIN_RESPONSE_SUCCESS,
    });
  }

  static receiveLoginError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.LOGIN_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  //
  //

  static logout() {
    AppDispatcher.handleServerAction({
      type: ActionTypes.LOGOUT
    });
  }

  //
  // TODO: move
  //

  static receiveRestaurant(restaurant: Restaurant) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.RESTAURANT_RESPONSE_SUCCESS,
      restaurant
    });
  }

  static receiveRestaurantError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.RESTAURANT_RESPONSE_FAILURE,
      apiError
    });
  }

}
